import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children"];
import * as React from 'react';
import * as styles from './Button.css';
import cn from 'classnames';
export var EButtonIntent;

(function (EButtonIntent) {
  EButtonIntent["Primary"] = "primary";
  EButtonIntent["Secondary"] = "secondary";
  EButtonIntent["Tertiary"] = "tertiary";
  EButtonIntent["Arc"] = "arc";
})(EButtonIntent || (EButtonIntent = {}));

export function Button(_ref) {
  var _cn;

  var children = _ref.children,
      props = _objectWithoutProperties(_ref, _excluded);

  var type = props.type || 'button';
  var dataMark = props.dataMark || 'Button';
  var intent = props.intent || EButtonIntent.Secondary;
  return /*#__PURE__*/React.createElement("button", {
    "data-mark": dataMark,
    type: type,
    onClick: props.onClick,
    disabled: props.disabled,
    className: cn(styles['btn'], (_cn = {}, _defineProperty(_cn, styles['btn-fill'], props.fill), _defineProperty(_cn, styles['btn-loading'], props.loading), _defineProperty(_cn, styles['btn-primary'], intent === EButtonIntent.Primary), _defineProperty(_cn, styles['btn-secondary'], intent === EButtonIntent.Secondary), _defineProperty(_cn, styles['btn-tertiary'], intent === EButtonIntent.Tertiary), _defineProperty(_cn, styles['btn-arc'], intent === EButtonIntent.Arc), _cn))
  }, props.loading && /*#__PURE__*/React.createElement("div", {
    className: styles['spinner']
  }, /*#__PURE__*/React.createElement("svg", {
    width: "18",
    height: "18",
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 9C1 10.5822 1.46919 12.129 2.34824 13.4446C3.22729 14.7602 4.47672 15.7855 5.93853 16.391C7.40034 16.9965 9.00887 17.155 10.5607 16.8463C12.1126 16.5376 13.538 15.7757 14.6569 14.6569C15.7757 13.538 16.5376 12.1126 16.8463 10.5607C17.155 9.00888 16.9965 7.40034 16.391 5.93853C15.7855 4.47672 14.7602 3.22729 13.4446 2.34824C12.129 1.46919 10.5823 1 9 1",
    stroke: "currentColor",
    strokeWidth: "2"
  }))), /*#__PURE__*/React.createElement("span", {
    className: cn(styles['content'], _defineProperty({}, styles['content-loading'], props.loading))
  }, children));
}